import Vue from 'vue'
import App from './App.vue'
import router from './router'; // 导入 Vue Router 路由
import store from './store';
import 'normalize.css/normalize.css';
import 'element-ui/lib/theme-chalk/index.css'; // 引入element ui 样式
import Element from 'element-ui'; // 导入 Element UI 组件库
import { checkAndHandleUserCenterAuth } from './utils/authHandler'
import { getUserInfoApi } from '@/api/auth'

Vue.use(Element, { size: 'small' }); // 使用 Element UI，并设置默认组件尺寸为 small

Vue.config.productionTip = false

// 在应用初始化时检查用户中心返回的认证信息
checkAndHandleUserCenterAuth().then(async (isAuthenticated) => {
  if (isAuthenticated) {
    console.log('用户中心认证成功')
  }
  
  // 应用启动时自动刷新token并获取用户信息（如果有有效refreshToken）
  const refreshToken = store.getters['auth/refreshToken']
  if (refreshToken) {
    console.log('检测到有效refreshToken，自动刷新token并获取用户信息')
    try {
      // 刷新token
      const response = await store.dispatch('auth/refreshToken')
      if (response) {
        console.log('token刷新成功')
        // 获取用户信息
        const userInfoResponse = await getUserInfoApi()
        if (userInfoResponse.code === 200 && userInfoResponse.data) {
          // 同步用户信息到user模块
          await store.dispatch('user/login', {
            token: response,
            userInfo: userInfoResponse.data
          })
          console.log('用户信息获取成功')
        }
      }
    } catch (error) {
      console.error('自动刷新token失败:', error)
      // 刷新失败时清除认证状态
      await store.dispatch('auth/logout')
      await store.dispatch('user/logout')
    }
  }
  
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
  });
})
